import * as Sentry from "@sentry/react";
import React from "react";

import CompanySettings from "./CompanySettings";

import { companySettingsQuery, currentUserQuery } from "../../../../../api/queries";
import { dataLoader } from "../../../../../api/queries/dataLoader";

/**
 * Data loader for company settings page.
 * Preloads company settings and current user data.
 */
export const companySettingsLoader = () => {
	const queries = [companySettingsQuery];
	return dataLoader([[currentUserQuery], queries]);
};

/**
 * Admin Company Settings page wrapper with error boundary.
 */
const AdminCompanySettings: React.FC = () => {
	return (
		<Sentry.ErrorBoundary fallback={undefined}>
			<CompanySettings />
		</Sentry.ErrorBoundary>
	);
};

export default AdminCompanySettings;
